import { render, staticRenderFns } from "./ProjectTasks.vue?vue&type=template&id=f30ec948&scoped=true&"
import script from "./ProjectTasks.vue?vue&type=script&lang=js&"
export * from "./ProjectTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f30ec948",
  null
  
)

export default component.exports